/**
 * Shared console logging utility
 * Checks user preference for console logs (stored in localStorage or user data)
 * Falls back to global debug mode if user preference not available
 */

/**
 * Check if console logs should be shown
 * @returns {boolean} True if logs should be shown
 */
function shouldShowLogs() {
  // Check localStorage for user preference first
  const userPreference = localStorage.getItem('trip147_show_console_logs');
  if (userPreference !== null) {
    return userPreference === 'true';
  }
  
  // Fallback to global debug mode
  const debugMode = localStorage.getItem('tripsy_debug_mode');
  return debugMode === 'true';
}

/**
 * Conditional console.log
 * @param {...any} args - Arguments to log
 */
export function clog(...args) {
  if (shouldShowLogs()) {
    console.log(...args);
  }
}

/**
 * Conditional console.info
 * @param {...any} args - Arguments to log
 */
export function cinfo(...args) {
  if (shouldShowLogs()) {
    console.info(...args);
  }
}

/**
 * Conditional console.warn
 * @param {...any} args - Arguments to log
 */
export function cwarn(...args) {
  if (shouldShowLogs()) {
    console.warn(...args);
  }
}

/**
 * Conditional console.error
 * @param {...any} args - Arguments to log
 */
export function cerror(...args) {
  if (shouldShowLogs()) {
    console.error(...args);
  }
}

/**
 * Set user's console logs preference
 * @param {boolean} enabled - Whether to enable console logs
 */
export function setConsoleLogsPreference(enabled) {
  localStorage.setItem('trip147_show_console_logs', enabled.toString());
}

